module.exports = __webpack_public_path__ + "img/yh_19.fdbba8ef.png";